import { Checkbox, Form } from "antd";
import React, { useState } from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const FormCheckbox = ({ name, initialValue, label = "Check box" }) => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Form.Item initialValue={initialValue} name={name} valuePropName="checked">
      <span>
        <Checkbox defaultChecked={initialValue} /> {label}
      </span>
    </Form.Item>
  );
};
export default FormCheckbox;
